export interface LegalSectionProps {
  title: string;
  terms: string;
}

export const LegalSection: React.FC<LegalSectionProps> = ({ title, terms }) => (
  <div className="container py-8 px-4">
    <h4>{title}</h4>
    <p className="py-6 pl-6 whitespace-pre-line">{terms}</p>
  </div>
);
